export default __webpack_public_path__ + "static/media/swipe-up.9ef12179.png";